import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { LottieAnimationPlayerComponent } from './lottie-animation-player.component'
import { LottieModule } from 'ngx-lottie'
import player from 'lottie-web'

export function playerFactory() {
  return player
}

@NgModule({
  declarations: [LottieAnimationPlayerComponent],
  imports: [CommonModule, LottieModule.forRoot({ player: playerFactory })],
  exports: [LottieAnimationPlayerComponent],
})
export class LottieAnimationPlayerModule {}
